import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ContactType } from 'handlers/yourContact';
import { useResendLogic } from 'hooks/useResendLogic';

interface UseResendConfirmationModalConfig {
  contactType: ContactType;
  contactValue: string;
  performResend: () => Promise<void>;
}

export const useResendConfirmationModal = ({
  contactType,
  contactValue,
  performResend,
}: UseResendConfirmationModalConfig) => {
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const navigate = useNavigate();
  const { recordSent, shouldShowConfirmation } = useResendLogic(contactType);

  const onResendCode = async () => {
    if (shouldShowConfirmation) {
      setShowConfirmationModal(true);
      return;
    }

    await performResend();
  };

  const handleConfirmResend = async () => {
    setShowConfirmationModal(false);
    await performResend();
  };

  const handleGoBack = () => {
    setShowConfirmationModal(false);
    navigate(-1);
  };

  const handleCloseModal = () => {
    setShowConfirmationModal(false);
  };

  const resendConfirmationModalProps = {
    isOpen: showConfirmationModal,
    contactValue,
    contactType,
    onConfirm: handleConfirmResend,
    onGoBack: handleGoBack,
    onClose: handleCloseModal,
  };

  return {
    showConfirmationModal,
    resendConfirmationModalProps,
    onResendCode,
    recordSent,
  };
};
